import React from 'react';
import ExperimentLayout from '../../components/experiments/ExperimentLayout';
import ReorderableList from '../../components/experiments/ReorderableList';

const ReorderableListExperiment: React.FC = () => {
  return (
    <ExperimentLayout
      title="Reorderable List"
      summary="Click to promote or drag to reorder items. Demonstrates immutable state updates and framer-motion's layout/reorder primitives."
      meta={[
        <span key="interaction" className="px-2 py-1 rounded-md bg-brand-500/10 text-brand-200">interaction</span>,
        <span key="motion" className="px-2 py-1 rounded-md bg-brand-400/10 text-brand-100">framer-motion</span>,
        <span key="state" className="px-2 py-1 rounded-md bg-brand-300/10 text-brand-100">state-updates</span>
      ]}
    >
      <div className="space-y-6">
        <section className="space-y-3">
          <h2 className="text-base font-medium text-white/80">Click-to-Top Version</h2>
          <p className="text-xs text-white/50 max-w-prose">Each click copies the array, removes the clicked item (splice(index,1)), unshifts it, providing a new reference for React diffing.</p>
          <BasicClickList initial={['Alpha','Bravo','Charlie','Delta']} />
        </section>
        <section className="space-y-3">
          <h2 className="text-base font-medium text-white/80">Drag & Drop Version</h2>
          <p className="text-xs text-white/50 max-w-prose">`Reorder.Group` + `Reorder.Item` handle position transitions and spring physics automatically.</p>
          <ReorderableList initial={['Alpha','Bravo','Charlie','Delta']} label="Drag items" />
        </section>
      </div>
    </ExperimentLayout>
  );
};

const BasicClickList: React.FC<{ initial: string[] }> = ({ initial }) => {
  const [items, setItems] = React.useState(initial);
  return (
    <ul className="space-y-1">
      {items.map((it, i) => (
        <li key={it}>
          <button
            type="button"
            onClick={() => {
              setItems(prev => {
                const copy = [...prev];
                const [picked] = copy.splice(i, 1);
                copy.unshift(picked);
                return copy;
              });
            }}
            className="w-full text-left rounded-md px-3 py-1.5 bg-brand-500/10 hover:bg-brand-500/20 focus:outline-none focus:ring-2 focus:ring-brand-400/60 text-xs text-white/85 transition"
          >
            {it}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default ReorderableListExperiment;
